<!--
 * @Author:
 * @Description: 审核流程组件
-->
<template>
  <div class="h-full overflow-y-auto bg-[#f5f7fa] px-10px py-20px">
    <div class="mb-20px">
      <el-radio-group
        v-model="form.isPass"
        class="mb-20px"
        size="mini"
        :disabled="approveStatus === 4 || approveStatus === 5"
      >
        <el-radio class="mr-0px" :label="1" border>同意</el-radio>
        <el-radio :label="0" border>作废</el-radio>
      </el-radio-group>
      <el-input
        v-model="form.opinion"
        placeholder="请输入意见/评论"
        clearable
        type="textarea"
        class="mb-10px"
        :disabled="approveStatus === 4 || approveStatus === 5"
      ></el-input>
      <el-button
        type="primary"
        size="mini"
        :loading="checkLoading"
        @click="handleWork"
        :disabled="approveStatus === 4 || approveStatus === 5 || form.isPass === null"
        >处理工作</el-button
      >
    </div>
    <div>
      <el-button type="primary" size="mini" class="mb-10px" @click="openFlowDialog">
        查看流程图
      </el-button>
    </div>
    <!-- 流程节点 -->
    <div v-for="(item, index) in flowList" :key="index">
      <div class="flex text-14px relative">
        <div class="absolute left-15px h-full border-l-[1px] border-gray-300"></div>
        <div class="absolute flex justify-center items-center">
          <div class="w-30px h-30px leading-20px rounded-1/2 overflow-hidden">
            <img
              class="w-30px h-30px"
              :src="`${currentEnv.VUE_APP_DIY_AVATAR_PATH}${item.Avatar}`"
              alt=""
              v-if="item.Avatar"
            />
            <div class="w-30px h-30px bg-[#c0c4cc]" v-else></div>
          </div>
        </div>
        <div class="relative pl-40px pt-5px flex flex-col">
          <div class="flex-1">
            <div class="flex">
              <div class="mr-10px font-700 leading-20px">{{ item.Sender }}</div>
              <div
                v-if="item.ApprovalType && item.ApprovalType === 'Agree'"
                class="
                  mr-10px
                  text-[#14ce67]
                  p-2px
                  pl-5px
                  pr-5px
                  bg-[#e7faf0]
                  border-[#14ce67] border-1px
                  rounded-5px
                "
              >
                同意
              </div>
              <div
                v-if="item.ApprovalType && item.ApprovalType === 'Disagree'"
                class="
                  mr-10px
                  text-[#ff4f55]
                  p-2px
                  pl-5px
                  pr-5px
                  bg-[#ffeded]
                  border-[#fedede] border-1px
                  rounded-5px
                "
              >
                不同意
              </div>
              <div
                class="
                  text-[#1890ff]
                  p-2px
                  pl-5px
                  pr-5px
                  bg-[#e8f4ff]
                  border-[#d1e9ff] border-1px
                  rounded-5px
                "
              >
                {{ item.FromNodeName }}
              </div>
            </div>
            <div class="text-[#666] mt-10px">{{ item.ApprovalIdea }}</div>
            <div v-if="item.Receivers && item.Receivers.length > 0" class="mt-5px">
              <div class="w-full h-1px bg-[#dcdfe6] mt-20px mb-20px relative">
                <div class="absolute left-20px bg-[#f5f7fa] pl-20px pr-20px -top-10px">
                  <div
                    class="
                      h-20px
                      leading-16px
                      pl-5px
                      pr-5px
                      text-[#1890ff]
                      bg-[#e8f4ff]
                      border-[#d1e9ff] border-1px
                      rounded-5px
                    "
                  >
                    接收人
                  </div>
                </div>
              </div>
              <div>
                <div
                  class="mb-5px mr-5px flex inline-block float-left"
                  v-for="(access, aIndex) in item.Receivers"
                  :key="aIndex"
                >
                  <div
                    class="
                      h-24px
                      leading-20px
                      rounded-12px
                      bg-[#ffeded]
                      border-[#fedede] border-1px
                      text-[#ff4f55]
                      flex
                    "
                  >
                    <div class="w-20px h-20px leading-20px rounded-1/2 overflow-hidden">
                      <img
                        class="w-20px h-20px"
                        :src="`${currentEnv.VUE_APP_DIY_AVATAR_PATH}${access.Avatar}`"
                        alt=""
                        v-if="access.Avatar"
                      />
                      <div class="w-20px h-20px bg-[#c0c4cc]" v-else></div>
                    </div>
                    <div class="flex-1 pl-5px pr-5px">{{ access.Name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-[#999] mt-10px mb-10px h-14px">{{ item.CreateTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataApprovalService from '@/services/dataApprovalService'
import DataRuleSettingService from '@/services/DataRuleSettingService'

export default {
  name: 'workflow',
  props: {
    flowId: {
      type: String,
      default: '',
    }, // 工作流id
    approveStatus: {
      type: Number,
      default: 0,
    }, // 审批状态
    batchId: {
      type: String,
      default: '',
    }, // 批次id
  },
  data() {
    return {
      form: {
        opinion: '',
        isPass: null,
      },
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      dialogVisible: false,
      graphData: {
        nodes: [],
        edges: [],
      }, // grapg图数据
      flowList: [], // 流程节点数据
      checkLoading: false,
      workFlowData: {}, // 工作流数据
      WFWorkData: {}, // 工作数据
    }
  },
  watch: {
    flowId: {
      handler(newValue) {
        if (!newValue) return
        this.getWFHistory()
      },
    },
  },
  methods: {
    async getWFWork() {
      const formData = new FormData()
      formData.append('FlowId', this.workFlowData.workFlowId)
      formData.append('WorkType', 'Todo')
      const res = await DataRuleSettingService.getWFWork(formData)
      if (res && res.Code === 1) {
        this.WFWorkData = res.Data[0]
      }
    },

    /**
     * @description 工作流审批
     */
    async handleWork() {
      if (!this.flowId || !this.batchId) return
      const res = await DataApprovalService.batchApprove({
        flowId: this.flowId,
        batchId: this.batchId,
        opinion: this.form.opinion,
        isPass: !!this.form.isPass,
      })
      if (res && res.code === 0) {
        this.form = this.$options.data().form
        this.$message.success('成功')
        this.$emit('approvalSuccess')
        this.getWFHistory()
      }
    },
    // 获取审批流程
    async getWFHistory() {
      const formData = new FormData()
      formData.append('FlowId', this.flowId)
      const res = await DataRuleSettingService.getWFHistory(formData)
      if (res && res.Code === 1) {
        this.flowList = _.map(res.Data, (item) => {
          item.Receivers = item.Receivers ? JSON.parse(item.Receivers) : []
          item.userList = [{ Id: item.SenderId, Name: item.Sender }].concat(item.Receivers)
          return item
        })
        this.getUserAvatar()
      }
    },
    // 获取用户头像
    async getUserAvatar() {
      let userList = []
      _.map(this.flowList, (item) => {
        userList = userList.concat(item.userList)
      })
      const formData = new FormData()
      _.forEach(userList, (item, index) => {
        formData.append(`Ids[${index}]`, item.Id)
      })
      const res = await DataRuleSettingService.getUserAvatar(formData)
      if (res && res.Code === 1) {
        _.map(this.flowList, (item) => {
          this.$set(item, 'Avatar', _.find(res.Data, ['Id', item.SenderId]).Avatar)
          _.map(item.Receivers, (uItem) => {
            this.$set(uItem, 'Avatar', _.find(res.Data, ['Id', uItem.Id]).Avatar)
            return uItem
          })
          return item
        })
      }
    },

    /**
     * @description 查看低代码流程图
     */
    openFlowDialog() {
      window.wiz.OpenWorkFlowDesignByFlowId(this.flowId)
    },
  },
}
</script>
